export const getAnswerFeedbackData = (target, externalData) => {
  var _challengesData$answe;
  const challengesData = externalData;
  return challengesData == null || (_challengesData$answe = challengesData.answers) == null ? void 0 : _challengesData$answe[target];
};
//# sourceMappingURL=get-answers.js.map